import * as types from './mutations-types'

const setDados = async ({dispatch, commit}, obj) => {
  const {centroCustoId, competenciaId} = obj
  let path = `competencia/${competenciaId}/centrocusto/${centroCustoId}`
  const {data: {competencia, centroCusto}} = await axios.get(`${process.env.API_PATH}/${path}`)
  dispatch('setCompetencia', {competencia})
  dispatch('setCentroCusto', {centroCusto})
  commit(types.SET_TO_UPDATE, {state: false})
}

const setCompetencia = async ({commit}, obj) => {
  const {data} = await axios.get(`${process.env.API_PATH}/competencia/ano/${obj.ano}/mes/${obj.mes}`)
  commit(types.SET_COMPETENCIA, {competencia: data})
}

const update = async ({commit}, obj) => {
  const {data} = await axios.put(`${process.env.API_PATH}/competencia/${obj.id}`, obj)
  commit(types.SET_COMPETENCIA, {competencia: data})
}

const setCentroCusto = async ({commit}, obj) => {
  const {centroCustoId, competenciaId} = obj
  let path = `competencia/${competenciaId}/centrocusto/${centroCustoId}`
  const {data} = await axios.get(`${process.env.API_PATH}/${path}`)
  commit(types.SET_CENTRO_CUSTO, {centroCusto: data})
}

const restaurarPesos = async ({dispatch, commit, state}, obj) => {
  const {centroCustoId, parentId} = obj
  const {data} = await axios.post(`${process.env.API_PATH}/meta/peso/restaura`, {centroCustoId, parentId})
  commit(types.SET_TO_UPDATE, {state: true})
}

const restaurarPesosArvoreCompetencia = async ({dispatch, commit, state}, obj) => {
  const {arvoreId, parentId} = obj
  const {data} = await axios.post(`${process.env.API_PATH}/meta/peso/restaura`, {centroCustoId, parentId})
  commit(types.SET_TO_UPDATE, {state: true})
}


const atualizarMetas = async ({commit}, obj) => {
  const {metas} = obj
  const {data} = await axios.put(`${process.env.API_PATH}/meta`, {metas})
  commit(types.SET_TO_UPDATE, {state: true})
}

const executaProcesso = async ({commit}, obj) => {
  const {id} = obj
  const {data} = await axios.post(`${process.env.API_PATH}/processo/${id}/execute`, {id})
  commit(types.SET_TO_UPDATE, {state: true})
}
export default {
  setCompetencia, setCentroCusto, restaurarPesos, atualizarMetas, executaProcesso, update
}



// WEBPACK FOOTER //
// ./src/features/Competencia/store/actions.js